import { createFileRoute } from '@tanstack/react-router';
import Contact from '~/containers/Contact';

export const Route = createFileRoute('/contact')({
  component: Contact,
});
